//import Moment from "moment";

const dataFormatada = (state) => {
    if (!state.fornecedor || !state.fornecedor.data) return null;
    return Moment(String(state.fornecedor.data)).format("DD/MM/YYYY");
}

const getCount = (state) => {
	return state.fornecedores.length;
}

const getStatusAtualizacaoListaFornecedor = (state) => {
	if (state.ultimaAtualizacaoListaFornecedor == null) {
		return true;
	}
	else if(!state.fornecedores)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.fornecedores.length == 0 ||
			hour - state.ultimaAtualizacaoListaFornecedor.getHours() > 0
		);
	}
}
export default {
    dataFormatada,
	getCount,
    getStatusAtualizacaoListaFornecedor
}